export const getDelegatesColumns = () => [
  {
    field: 'firstName',
    title: 'Manager Name',
    align: 'left',
    disableSorting: true,
    render: row => `${row.firstName} ${row.lastName}`
  },
  { field: 'email', title: 'Email', align: 'left', collapsible: true },
  { field: 'phone', title: 'Phone', align: 'left', collapsible: true },
  {
    field: 'status',
    title: 'Status',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => (row.isEnabled ? 'Enabled' : 'Disabled')
  }
]

export const getAssignmentsColumns = () => [
  {
    field: 'person.globalId',
    title: 'GlobalID',
    align: 'left',
    width: '100px',
    render: row => row.person?.globalId || ''
  },
  {
    field: 'globalId',
    title: 'Marca',
    align: 'left',
    width: '100px',
    render: row => row.globalId || ''
  },
  {
    field: 'person.firstName',
    title: 'Partner Name',
    align: 'left',
    disableSorting: true,
    render: row => `${row.person.firstName} ${row.person.lastName}`
  },
  {
    field: 'email',
    title: 'Email',
    align: 'left',
    collapsible: true,
    render: row => row.email
  },
  {
    field: 'person.phone',
    title: 'Phone',
    align: 'left',
    collapsible: true,
    render: row => row.person.phone
  },
  {
    field: 'manager',
    title: 'Manager',
    align: 'left',
    collapsible: true,
    disableSorting: true,
    render: row => `${row.manager.firstName} ${row.manager.lastName}`
  },
  {
    field: 'externalPartnerType.name',
    title: 'Type',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => row.externalPartnerType.name
  },
  {
    field: 'status',
    title: 'Status',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => row.status.name
  }
]
